import { compose, createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './rootReducer';
import persistConfig from './persistConfig';

const composeEnhancers
  = typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // trace: true, // Tracing every action is a large performance hit, enable only when needed.
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(reduxThunk)
);

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, enhancer);

export const persistor = persistStore(store);

export default store;
